<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h1 data-test-id="ad-set-trace-title">Internal Tools & Help</h1>
        <br />
        <div class="tools-page_link-section">
          <div class="tools-page_link">
            <a href="/tools/ad-set-trace">Where's my Ad Set?</a>
          </div>
          <div class="tools-page_link">
            <a href="/tools/price-check">Price Check</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "ToolsPage",
  data() {
    return {
      loading: false,
    };
  },
};
</script>

<style scoped>
.tools-page_link-section {
  font-size: 2rem;
}
.tools-page_link:hover {
  transform: scale(1.005);
  animation: 0.25 ease-in-out;
}
</style>